import { useEffect } from 'react';
import FamilyPanel from './FamilyPanel';

// Same translucent "Start menu" treatment as DockMenu, but shows only the
// Family panel — nothing else from the full profile page.
export default function FamilyFlyout({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <div className="dockmenu-backdrop" onClick={onClose} />
      <div className="dockmenu familyflyout" onClick={e => e.stopPropagation()}>
        <FamilyPanel />
      </div>
    </>
  );
}
